import React from 'react';
import { Row, Col } from 'antd';
import { TitleForm } from './TitleForm';
import {
	LineFormItem,
	SectorFormItem,
	WorkersFormItem,
	CompanyFormItem,
	TrainingFormItem,
	EmployerFormItem,
	EvaluatorFormItem,
	WorkstationFormItem,
	OrganizationFormItem,
	WorkersNumberFormItem,
	EvaluationNameFormItem,
	SymptomLocationFormItem,
	EarlyManifestationFormItem,
	ResponsibleHygieneServiceFormItem,
	ResponsibleMedicineServiceFormItem,
	WrittenWorkProcedureFormItem
} from '../../../components/Form';
import type { FormDataValues } from '@/context/Resolution886Report/types';

interface GeneralInformationFormProps {
	fieldNameKey?: FormDataValues['general_information'];
}

export function GeneralInformationForm({
	fieldNameKey = 'general_information'
}: Readonly<GeneralInformationFormProps>): JSX.Element {
	return (
		<Row gutter={[16, 16]} align="bottom">
			<Col span={24} style={{ marginBottom: '20px' }}>
				<TitleForm title="General Information" subtitle="Enter the data related to the evaluation." />
			</Col>
			<Col span={6}>
				<OrganizationFormItem fieldName={[fieldNameKey, 'organization_id']} disabled />
			</Col>
			<Col span={6}>
				<CompanyFormItem fieldName={[fieldNameKey, 'company_id']} disabled />
			</Col>
			<Col span={6}>
				<SectorFormItem fieldName={[fieldNameKey, 'sector_id']} required />
			</Col>
			<Col span={6}>
				<LineFormItem fieldName={[fieldNameKey, 'line_id']} />
			</Col>
			<Col span={6}>
				<WorkstationFormItem fieldName={[fieldNameKey, 'workstation_id']} />
			</Col>
			<Col span={6}>
				<EvaluationNameFormItem fieldName={[fieldNameKey, 'name']} />
			</Col>
			<Col span={6}>
				<WorkersNumberFormItem fieldName={[fieldNameKey, 'workers_number']} />
			</Col>
			<Col span={6}>
				<WorkersFormItem fieldName={[fieldNameKey, 'worker_list_id']} />
			</Col>
			<Col span={6}>
				<WrittenWorkProcedureFormItem fieldName={[fieldNameKey, 'written_work_procedure']} />
			</Col>
			<Col span={6}>
				<TrainingFormItem fieldName={[fieldNameKey, 'training']} />
			</Col>
			<Col span={6}>
				<EarlyManifestationFormItem fieldName={[fieldNameKey, 'early_manifestation']} />
			</Col>
			<Col span={6}>
				<SymptomLocationFormItem fieldName={[fieldNameKey, 'symptom_location']} />
			</Col>
			<Col span={6}>
				<EvaluatorFormItem fieldName={[fieldNameKey, 'evaluator_id']} />
			</Col>
			<Col span={6}>
				<EmployerFormItem fieldName={[fieldNameKey, 'employer_id']} />
			</Col>
			<Col span={6}>
				<ResponsibleMedicineServiceFormItem fieldName={[fieldNameKey, 'occupational_doctor_id']} />
			</Col>
			<Col span={6}>
				<ResponsibleHygieneServiceFormItem fieldName={[fieldNameKey, 'safety_and_hygiene_responsible_id']} />
			</Col>
		</Row>
	);
}
